import { combineReducers } from 'redux';
import exerciseEntities from './exerciseEntities';
import feedbackMessages from './feedbackMessages';
import localExercises from './localExercises';
import multipleChoiceExerciseUi from './multipleChoiceExerciseUi';
import userWorkbooks from './userWorkbooks';
export default combineReducers({
  exerciseEntities,
  feedbackMessages,
  localExercises,
  multipleChoiceExerciseUi,
  userWorkbooks
});